export enum NotificationTypeEnum {
  VENDOR_ORDER_PLACED_SMS = 'vendor-order-placed-sms',
  VENDOR_ORDER_PLACED_EMAIL = 'vendor-order-placed-email',
  USER_ACCOUNT_CREATED_SMS = 'user-account-created-sms',
  USER_ACCOUNT_CREATED_EMAIL = 'user-account-created-email',
  REP_ACCOUNT_CREATED_SMS = 'rep-account-created-sms',
  REP_ACCOUNT_CREATED_EMAIL = 'rep-account-created-email',
  SIGNUP_SUCCESS_EMAIL = 'signup-success-email',
  RESTAURANT_LIMIT_EXCEEDED = 'restaurant-limit-exceeded',
  SUBSCRIPTION_REDUCTION_EMAIL = 'subscription-reduction-email',
  RESTAURANTS_DISABLED_EMAIL = 'restaurants-disabled-email',
  EOD_REPORT_CREATED_EMAIL = 'eod-report-created-email',
  SUBSCRIPTION_CHANGES_EMAIL = 'subscription-changes-email'
}
